import React, { useEffect, useState } from 'react';
import './WidgetWrapper.scss';
import getSetCookie from '../../../../cookie';
import config from '../../../../config';
// import WishListIcon from '../../../../CommonComponents/ProductCard/WishListIcon';
// import Rating from '../../../../CommonComponents/ProductCard/Rating';
// import ProductTitle from '../../../../CommonComponents/ProductCard/ProductTitle';
// import ProductDetails from '../../../../CommonComponents/ProductCard/ProductDetails';
// import Pricing from '../../../../CommonComponents/ProductCard/Pricing';
// import sessionStorageHelper from '../../../../utils/sessionStorageHelper';
// import { addToWishListGA4 } from '../../../../utils/gaFour';
// import ProductColorOptions from '../../../../CommonComponents/ProductCard/ProductColorOptions';
// import ProductOffer from '../../../../CommonComponents/ProductCard/ProductOffer';
// import { Link } from 'react-router-dom';
// import SimilarProducts from './SimilarProducts';
// import ProductImage from '../../../../CommonComponents/ProductCard/ProductImage';
import { connect } from 'react-redux';
import { onImageLoadError, removeDomainName, roundUptoDigits } from '../../../../utils/helper';
import { bindActionCreators } from 'redux';
import * as dittoActions from '../../../../actionCreators/ditto';
import { replaceImageURL } from '../../../../own-days/helper';
// import ODProductCard from '../../../../own-days/CommonComponents/ODProductCard/ODProductCard';
import ODProductCardV2 from '../../../../own-days/CommonComponents/ODProductCardV2/ODProductCardV2';

let client = 'mobilesite';
// conditional imports on compilation
('#if CLIENT_TYPE === "desktop"'); // eslint-disable-line
client = 'desktop';
('#endif'); // eslint-disable-line

// const stylePricing = {
//   fontSize: '16px',
//   color: '#000042',
//   lineHeight: '18px',
// };

const WidgetWrapper = props => {
  const {
    shortListData,
    productData,
    showDitto,
    dittoFound,
    productUrl,
    productImage,
    isExchange,
    colorObj,
    localeInfo,
    gaqEventsPush,
    setHoverImage,
    redisCommonData,
    colorOptions,
    mouseInColor,
    mouseOutColor,
    catImgPattern,
    catImgSmall,
    userInfo,
    dittoEnable,
    onImageError,
    colorIndex,
    indexOfProduct,
    productSelectCallback,
    // dataLocale,
    // redisLoader,
    // overlayedDittoData,
    // dittoGuestId,
    // dittoActions,
    // shortlistLimitReached,
    // setWishList,
    // login,
    // currencyMark,
    // PRODUCT_OFFERID_CONFIG_DESKTOP,
  } = props;
  console.log('🚀 ~ WidgetWrapper ~ productData:', productData);
  let _isMounted = false;
  let isShortlisted = false;
  let viewImage;
  // let exchangeText;
  // let exchangeFreeText;
  // let subSelection = 'default';

  const [dittoImage, setDittoImage] = useState(null);
  // const [exchangePrice, setExchangePrice] = useState(null);
  // const [exchangeMarketPrice, setExchangeMarketPrice] = useState(null);
  // const [expanded, setExpanded] = useState(false);
  // const [enableSimilarProducts, setEnableSimilarProducts] = useState(false);

  // const setOpen = (e, state) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   setExpanded(state);
  // };

  const getDittoImage = sku => {
    const dittoAccessID = getSetCookie.getCookie('dittoAccessID');
    const dittoSignature = getSetCookie.getCookie('dittoSignature');
    if (getSetCookie.getCookie('isDittoID') && dittoSignature && dittoEnable) {
      if (redisCommonData?.ENABLE_CYGNUS) {
        // dittoActions.getOverlayedDitto(
        //   sku,
        //   userInfo?.result?.telephone,
        //   userInfo?.result?.phoneCode,
        //   dittoGuestId,
        //   client
        // );
        const headers =
          userInfo?.result?.telephone && userInfo?.result?.phoneCode
            ? {
                'X-Api-Client': client,
                'X-Customer-Phone': userInfo?.result?.telephone,
                'X-Customer-Phone-Code': userInfo?.result?.phoneCode,
              }
            : {
                'X-Api-Client': client,
              };
        let dittoGuestId = null;
        if (!(userInfo?.result?.telephone && userInfo?.result?.phoneCode))
          dittoGuestId = getSetCookie.getCookie('dittoGuestId');
        else dittoGuestId = null;
        fetch(
          `${config.cygnus.getOverlayedImageFromCygnus}?product_id=${sku}${
            dittoGuestId ? `&guest_id=${dittoGuestId}` : ''
          }&view=json`,
          { headers }
        )
          .then(resp => resp.json())
          .then(data => {
            setDittoImage(data?.overlayed_image_url);
          });
      } else {
        fetch(
          `${config.ditto.vtoUrl}${getSetCookie.getCookie(
            'isDittoID'
          )}/frontal-frame/?product_id=${sku}&size=300x240`,
          {
            headers: {
              'X-Ditto-Access-Key-Id': dittoAccessID,
              'X-Ditto-Signature': dittoSignature,
            },
          }
        )
          .then(res => res.blob())
          .then(url => {
            const image = URL.createObjectURL(url);
            setDittoImage(image);
          });
      }
    }
  };

  useEffect(() => {
    _isMounted = true;
    // const { ENABLE_SIMILAR_PRODUCTS } = redisCommonData;
    // if (ENABLE_SIMILAR_PRODUCTS) {
    //   setEnableSimilarProducts(JSON.parse(ENABLE_SIMILAR_PRODUCTS)?.desktop);
    // }
    if (!redisCommonData?.ENABLE_CYGNUS) getDittoImage(productData.id);
    return () => {
      _isMounted = false;
    };
  }, []);

  // * for pricing
  // useEffect(() => {
  //   const exchangeMarketPrice =
  //     productData &&
  //     productData.prices &&
  //     productData.prices.find(price => price.name === 'Market Price');
  //   const exchangePrice =
  //     productData &&
  //     productData.prices &&
  //     productData.prices.find(price => price.name === 'Lenskart Price');

  //   setExchangePrice(exchangePrice);
  //   setExchangeMarketPrice(exchangeMarketPrice);
  // }, [productData]);

  // for ditto image
  useEffect(() => {
    if (!redisCommonData?.ENABLE_CYGNUS && showDitto && productData.is_ditto) {
      getDittoImage(productData.id);
    }
  }, [showDitto]);

  useEffect(() => {
    if (redisCommonData?.ENABLE_CYGNUS && userInfo && showDitto && productData?.isCygnusEnabled) {
      getDittoImage(productData.id);
    }
  }, [userInfo, showDitto]);

  // * product image logic

  let displayProdName = productData.brand_name;
  if (productData.classification === 'contact_lens') {
    displayProdName += productData.model_name
      ? ` ${productData.model_name.replace(productData.brand_name, '')}`
      : '';
  }
  if (
    showDitto &&
    dittoFound &&
    ((!redisCommonData?.ENABLE_CYGNUS && productData.is_ditto) ||
      (redisCommonData?.ENABLE_CYGNUS && productData?.isCygnusEnabled)) &&
    dittoImage
  ) {
    viewImage = (
      <img
        alt={displayProdName}
        className={`${
          redisCommonData?.ENABLE_CYGNUS
            ? 'img-responsive cygnus_img margin-b20'
            : 'widget_dittoImg pos-rel'
        }`}
        src={replaceImageURL(dittoImage, localeInfo, productData.id)}
        title={displayProdName}
        onError={ev => onImageError(productData, ev)}
        onFocus={ev => setHoverImage('ditto', ev)}
        onMouseEnter={ev => setHoverImage('ditto', ev)}
        onMouseLeave={ev => setHoverImage('ditto', ev)}
      />
    );
    if (localeInfo.countryCode !== 'sg') {
      gaqEventsPush('Ditto', 'DittoNWF_Success', `prod_id:  ${productData.id}`);
    }
  } else {
    if (typeof colorObj === 'undefined') {
      viewImage = (
        <img
          alt={displayProdName}
          className="img-responsive"
          src={replaceImageURL(productImage, localeInfo, productData.id)}
          style={{ width: '100%' }}
          title={displayProdName}
          onError={ev => onImageLoadError(ev)}
          onFocus={ev => setHoverImage('ditto', ev)}
          onMouseEnter={ev => setHoverImage('enter', ev)}
          onMouseLeave={ev => setHoverImage('leave', ev)}
        />
      );
    } else {
      viewImage = (
        <img
          alt={displayProdName}
          className="img-responsive"
          src={
            colorIndex > 0
              ? replaceImageURL(
                  colorObj.image_urls[0].replace(catImgPattern, catImgSmall),
                  localeInfo,
                  productData.id
                )
              : replaceImageURL(productImage, localeInfo, productData.id)
          }
          style={{ margin: 'auto' }}
          title={displayProdName}
          onError={ev => onImageLoadError(ev)}
        />
      );
    }
    if (typeof _gaq === 'object' && localeInfo.countryCode !== 'sg') {
      gaqEventsPush('Ditto', 'DittoNWF_Failure', `prod_id:  ${productData.id}`);
    }
  }
  const productImageUrl = {
    pathname:
      productUrl &&
      removeDomainName(
        removeDomainName(productData.product_url, localeInfo?.domain),
        localeInfo?.domainUrl,
        localeInfo?.countryCode
      ),
    state: { productId: productData.id, section: 'prod' },
  };
  const productImageTarget = isExchange ? '' : '';

  // const isDittoVisible =
  //   showDitto &&
  //   dittoFound &&
  //   ((!redisCommonData?.ENABLE_CYGNUS && productData.is_ditto) ||
  //     (redisCommonData?.ENABLE_CYGNUS && productData?.isCygnusEnabled)) &&
  //   dittoImage;
  // const isProductVisible = !redisLoader && productImage;
  // const determineCardClass = (isDittoVisible, isProductVisible) => {
  //   if (isDittoVisible) {
  //     return '';
  //   }
  //   return isProductVisible ? 'margin-b40' : 'prod-img-container';
  // };

  // let dittoClasses = determineCardClass(isDittoVisible, isProductVisible);

  // dittoClasses +=
  //   showDitto &&
  //   dittoFound &&
  //   ((!redisCommonData?.ENABLE_CYGNUS && productData.is_ditto) ||
  //     (redisCommonData?.ENABLE_CYGNUS && productData?.isCygnusEnabled)) &&
  //   dittoImage
  //     ? ' padding-0'
  //     : ' padding-t15 padding-r15 padding-l15';

  const dittoSubClass =
    showDitto &&
    dittoFound &&
    !redisCommonData?.ENABLE_CYGNUS &&
    productData.is_ditto &&
    dittoImage &&
    !redisCommonData?.ENABLE_CYGNUS
      ? 'img-background'
      : '';
  const dittoStyle = {
    background:
      showDitto &&
      dittoFound &&
      !redisCommonData?.ENABLE_CYGNUS &&
      productData.is_ditto &&
      dittoImage
        ? `url(${dittoImage})`
        : 'none',
  };

  // * wishlist

  if (shortListData) {
    shortListData?.result?.productList?.forEach(slprd => {
      if (slprd.id === productData.id) {
        isShortlisted = true;
      }
    });
  }
  // const wishListHandler = () => {
  //   if (!isShortlisted && shortListData?.result?.numberOfProducts >= 50) {
  //     shortlistLimitReached();
  //     return;
  //   }
  //   if (window.dtm.LenskartRewamp) {
  //     if (isShortlisted) {
  //       window.dtm.LenskartRewamp.Listing.click.removeProdcutShortlist(
  //         login,
  //         productData.id.toString()
  //       );
  //     } else {
  //       window.dtm.LenskartRewamp.Listing.click.shortlist(productData.id.toString());

  //       if (typeof window.clevertap !== 'undefined') {
  //         window.clevertap.event.push('add_to_wishlist', {
  //           product_id: productData.id,
  //         });
  //       }
  //     }
  //   }
  //   addToWishListGA4(productData, login);
  //   setWishList(productData.id, shortListData);
  // };

  // * rating
  const rating = productData.avgRating
    ? roundUptoDigits(productData.avgRating, 1)
    : productData.avgRating;
  // const { totalNoOfRatings } = productData;

  // * pricing
  // if (login) {
  //   subSelection = userInfo?.result?.hasPlacedOrder ? 'repeat' : 'new';
  // }
  // const currencyCode =
  //   productData && productData.prices && productData.prices.length > 0
  //     ? productData.prices[0].currency_code
  //     : dataLocale.CURRENCY_CODE;
  // const currencySymbol = <span>{currencyMark[currencyCode]}</span>;

  // const { EXCHANGE_CONFIG } = redisCommonData;
  // if (isExchange && EXCHANGE_CONFIG) {
  //   const exchangeConfig = JSON.parse(EXCHANGE_CONFIG);
  //   exchangeFreeText = exchangeConfig && exchangeConfig.EXCHANGE_FREE_TEXT;
  //   exchangeText = exchangeConfig && exchangeConfig.EXCHANGE_TEXT;
  // }

  // const productOfferIdDetails =
  //   PRODUCT_OFFERID_CONFIG_DESKTOP &&
  //   PRODUCT_OFFERID_CONFIG_DESKTOP[productData.offerName] &&
  //   PRODUCT_OFFERID_CONFIG_DESKTOP[productData.offerName][subSelection];

  const lenskartPrice = productData.prices[1].price;
  const firstBuyPrice = productData.prices.length === 3 && productData.prices[2].price;
  const finalprice = productData.prices.length === 3 ? firstBuyPrice : lenskartPrice;

  const productColorsProps = {
    colorIndex,
    colorOptions,
    dittoFound,
    gaqEventsPush,
    mouseInColor,
    mouseOutColor,
    productData,
    productUrl,
    redisCommonData: props.redisCommonData,
    showDitto,
  };

  const productImageProps = {
    dittoClasses: 'padding-r0 padding-l0',
    dittoStyle,
    dittoSubClass,
    viewImage,
    productImageTarget,
    productImageUrl,
  };

  const raitingProps = {
    iconStyle: { height: 12, width: 12 },
    rating,
    // totalNoOfRatings,
  };

  return (
    <>
      {/* <ODProductCard
        device="desktop"
        finalprice={finalprice}
        indexOfProduct={indexOfProduct}
        product={productData}
        productColorsProps={productColorsProps}
        productImageProps={productImageProps}
        productSelectCallback={productSelectCallback}
        raitingProps={raitingProps}
      /> */}
      <ODProductCardV2
        indexOfProduct={indexOfProduct}
        product={productData}
        productSelectCallback={productSelectCallback}
      />
      {/** _____Product Link_____ */}
      {/* <Link
        className="no-decoration display-block"
        target={productImageTarget}
        to={productImageUrl}
      > */}
      {/** ______Product Image______ */}
      {/* <ProductImage
          dittoClasses="padding-r0 padding-l0"
          dittoStyle={dittoStyle}
          dittoSubClass={dittoSubClass}
          productImage={viewImage}
          target={productImageTarget}
          url={productImageUrl}
        />
      </Link>
      <div className="od-product-card-top">
        <div className="od-product-card-top__rating-wishlist"> */}
      {/** ______Product Rating______ */}
      {/* <Rating iconStyle={{ height: 19 }} rating={rating} totalNoOfRatings={totalNoOfRatings} /> */}

      {/** ________Wishlist Icon________ */}
      {/* <WishListIcon
            dataLocale={dataLocale}
            isShortlisted={isShortlisted}
            wishlistWrapperStyle={{ top: '-16px' }}
            onClickHandler={wishListHandler}
          />
        </div> */}

      {/** OD_NOT_REQ: ______Similar Products_______ */}
      {/* {productData?.relatedItems?.length && enableSimilarProducts ? (
          <div>
            <button className="rating-btn" onClick={e => setOpen(e, true)}>
              <span>
                <img
                  alt="rating-btn"
                  src="https://static1.lenskart.com/media/desktop/img/DesignStudioIcons/ViewSimilarIcon.svg"
                />
              </span>
              <span>{dataLocale?.VIEW_SIMILAR}</span>
            </button>
          </div>
        ) : null} */}

      {/** _____Color Options_____ */}
      {/* {colorOptions?.length || productData.color ? (
          <ProductColorOptions
            colorIndex={colorIndex}
            colorOptions={colorOptions}
            dittoFound={dittoFound}
            gaqEventsPush={gaqEventsPush}
            localeInfo={localeInfo}
            mouseInColor={mouseInColor}
            mouseOutColor={mouseOutColor}
            productData={productData}
            productUrl={productUrl}
            redisCommonData={props.redisCommonData}
            showDitto={showDitto}
          />
        ) : (
          <div style={{ minHeight: 31 }} />
        )}
      </div>

      <Link
        className="no-decoration display-block"
        target={productImageTarget}
        to={productImageUrl}
      >
        <div className="od-product-card-bottom"> */}
      {/** ______Product Title______ */}
      {/* <ProductTitle title={productData.brand_name} /> */}

      {/** ________Product Pricing______ */}
      {/* <Pricing
            currencySymbol={currencySymbol}
            dataLocale={dataLocale}
            finalprice={finalprice}
            localeInfo={localeInfo}
            productOfferIdDetails={productOfferIdDetails}
            stylePricing={stylePricing}
          /> */}

      {/** _______Product Model Name________ */}
      {/* <div className="od-product-model-name od-font-reg">{productData.model_name}</div>
        </div> */}

      {/** OD_NOT_REQ: _______Product Size, Product Suited For and Contact Lens_______ */}
      {/* <div className="product-details-wrapper">
          <div className="product-details-block">
            {productData.size && !productData.suited_for && (
                <ProductDetails size={productData.size} tags={productData.tags} text="Size" />
            )}
            {productData.suited_for && (
              <ProductDetails size={productData.suited_for} text={dataLocale.SUITED_FOR} />
            )}

            {productData.classification === 'contact_lens' && (
              <ProductDetails
                size={productData?.specifications[0]?.items[1]?.value}
                tags={productData?.specifications[0]?.items[0]?.value
                  .toLowerCase()
                  .replace(' per box', 'es')}
                text="Usage"
              />
            )}
          </div>
        </div> */}

      {/** OD_NOT_REQ: ______Product Offer_________ */}
      {/* {productOfferIdDetails && productOfferIdDetails?.text2 ? (
          <ProductOffer text={productOfferIdDetails && productOfferIdDetails?.text2} />
        ) : (
          <ProductOffer content text="" />
        )} */}
      {/* </Link> */}
      {/* {expanded && <SimilarProducts products={productData?.relatedItems} setOpen={setOpen} />} */}
    </>
  );
};

const mapStateToProps = state => {
  return {
    currencyMark: state.common.currencyMark,
    redisCommonData: state.common.redisCommonData,
    userInfo: state.common.userInfo,
    dittoEnable: state.category.dittoEnable,
    localeInfo: state.common.localeInfo,
    redisLoader: state.category.redisLoader,
    guestInfo: state.checkout.guestInfo,
    overlayedDittoData: state.ditto.overlayedDittoData,
    dittoGuestId: state.ditto.dittoGuestId,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    dittoActions: bindActionCreators(dittoActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WidgetWrapper);
